import EnumField from 'components/Enum/EnumField';
import * as React from 'react';
import {
  TextField,
  Datagrid,
  FunctionField,
  SimpleShowLayout,
  ReferenceManyField,
  Pagination,
  NumberField,
  DateField,
  EditButton,
} from 'react-admin';
import MoneyField from 'components/MoneyField';
import { displayShiftTypes } from 'resources/professional_saas_details/utils';

const IrmTab = () => (
  <SimpleShowLayout>
    <ReferenceManyField
      pagination={<Pagination />}
      label=""
      reference="ProfessionalSaasDetail"
      target="professional_id"
    >
      <Datagrid bulkActionButtons={false}>
        <TextField label="ID" source="id" />
        <NumberField
          label="Max Weekly Hours"
          source="max_weekly_hours"
          options={{ maximumFractionDigits: 2 }}
        />
        <MoneyField label="Hourly Rate" source="hourly_rate_cents" />
        <FunctionField
          label="Shift Types"
          render={(record) => displayShiftTypes(record?.shift_types)}
        />
        <EnumField label="Employment Type" source="employment_type" />
        <DateField label="Offboarded At" source="offboarded_at" />
        <TextField label="Offboarded Reason" source="offboarded_reason" />
        <EditButton />
      </Datagrid>
    </ReferenceManyField>
  </SimpleShowLayout>
);

export default IrmTab;
